module.exports = __webpack_public_path__ + "static/media/image14.5bb0cc2f.jpg";